var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"lists",staticClass:"lists nano"},[_c('div',{ref:"listsContent",staticClass:"nano-content"},_vm._l((_vm.lists),function(item,key){return _c('song-item',{key:key,attrs:{"current":_vm.current,"index":key,"obj":item,"isPlaying":_vm.isPlaying},on:{"songClick":_vm.on_song_click}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }